import { useQuery, useQueryClient } from '@tanstack/react-query';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import { mapDispatchProps, mapStateToProps } from '../../../../store/store';
import API from '../../../../api';

import { ROUTES } from 'routes';
import OnAfterModalClosed from '../../../../libraries/onAfterModalClosed';
import Builder from '../builder';
import RightSideOfDetail from '../rightSideOfDetail';
import { useLanguage } from '@languages/index';

const SNSVideoDetail = (props: any) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.sns };
  const params = useParams();
  const videoId = params.id;

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const onAfterModalClosed = new OnAfterModalClosed(props);

  console.log(props);

  /// state

  /// query
  // fetch brand
  const fetchBrandRes = useQuery({
    queryKey: ['fetch_brand'],
    queryFn: async () => {
      try {
        const res = await API.Brand.show({ brandToken: props.auth.token });
        props.setBrand(res.data.brand);

        return res;
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.celeb_detail_text_1,
        });
      }
    },
  });

  // fetch video review
  const fetchVideoRes = useQuery({
    queryKey: ['fetch_video_review', fetchBrandRes.data?.brand?.id, videoId],
    queryFn: async () => {
      try {
        const res = await API.BrandSns.fetchVideos({
          brandToken: props.auth.token,
          where: { id: videoId },
        });
        return res.data.reviews[0];
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.video_detail_text_1,
        });
      }
    },
    enabled: !!fetchBrandRes.data,
  });
  const dirtyfetchVideo = () =>
    queryClient.removeQueries({ queryKey: ['fetch_video_review'] });

  /// sns install check
  if (
    fetchBrandRes.data &&
    fetchBrandRes.data.brand &&
    fetchBrandRes.data.brand.hasExperiencedSnsInstall &&
    !fetchBrandRes.data.brand.snsPassInstalledAt
  ) {
    navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH);
  }

  /// other functions
  const _setVideoPublishState = async (value: boolean) => {
    const video = fetchVideoRes.data;
    if (!video || !!video.isPublished === value) return;

    try {
      props.showModal({
        hideCloseButton: true,
        hideConfirmButton: true,
        text: languageTexts.celeb_detail_text_3,
      });

      const res = await API.BrandSns.updateVideo(video.id, {
        brandToken: props.auth.token,
        masterToken: props.auth.masterToken,
        isPublished: value,
      });

      props.closeModal();
    } catch (error) {
      onAfterModalClosed.set(() => {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.video_detail_text_2,
        });
      });
      props.closeModal();
    }

    dirtyfetchVideo();
  };

  /// build main
  const build = () => {
    if (!fetchBrandRes.data || !fetchVideoRes.data) return null;

    if (!props.brand?.hasExperiencedSnsInstall || !props.brand?.remainSnsPass)
      return null;

    const video = fetchVideoRes.data;

    return (
      <div className="flex flex-col items-center w-[1025px] mx-auto my-[50px]">
        <div className="flex flex-row w-full">
          {Builder.buildBackwardText((e) => {
            navigate(ROUTES.SNS_INDEX.PATH);
          })}
        </div>

        <div style={{ height: '59px' }} />

        <div className="flex flex-row justify-start w-full">
          {/* left-side */}
          <div className="flex flex-col justify-start w-[400px]">
            {/* video */}
            <div
              className="cursor-pointer"
              onClick={() =>
                window.open(`https://www.youtube.com/watch?v=${video.videoKey}`)
              }
            >
              <div style={{ position: 'relative' }}>
                <img
                  className={'object-cover w-[400px] h-[225px]'}
                  src={`http://img.youtube.com/vi/${video.videoKey}/mqdefault.jpg`}
                />
                <img
                  className="flex-none"
                  style={{ position: 'absolute', top: '72px', left: '160px' }}
                  src="/assets/icons/playable.svg"
                />
                <span
                  className="pl-[7px] pr-[3px] py-[4px] font-bold text-[13px] text-[#ffffff] bg-[#0000003C]"
                  style={{ position: 'absolute', bottom: '0px', right: '0px' }}
                >
                  {video.duration}
                </span>
              </div>
              <div style={{ height: '10px' }} />
              <span className=" text-[15px]">{video.title}</span>
            </div>
          </div>

          {/* right-side */}
          <RightSideOfDetail
            review={video}
            onSetPublishState={(v) => {
              if (props.auth.isMaster) _setVideoPublishState(v);
            }}
            onEditClick={
              props.auth.isMaster
                ? () => {
                    navigate(ROUTES.SNS_UPLOAD_VIDEO.PATH + `?id=${video.id}`);
                  }
                : null
            }
            onBsProductUrlChanged={(r) => dirtyfetchVideo()}
          />
        </div>
      </div>
    );
  };

  return build();
};

export default connect(mapStateToProps, mapDispatchProps)(SNSVideoDetail);
